import React from "react";
import { TabHeader } from "components/TabHeader";
import TabComponent from "newui/components/TabComponent";
import type { TabMenuItem } from "newui/components/TabComponent/TabComponent";

/* -------------------------------------------------------------------------- */
/* Types                                                                      */
/* -------------------------------------------------------------------------- */

interface SettingsPageLayoutProps {
  activeTab: string;
  children: React.ReactNode;
  heading: string;
  isLoading?: boolean;
  tabs: TabMenuItem[];
  onTabChange: (name: string, id: string) => void;
}

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export const SettingsPageLayout: React.FC<SettingsPageLayoutProps> = ({
  heading,
  tabs,
  activeTab,
  onTabChange,
  isLoading = false,
  children,
}) => {
  return (
    <div>
      <TabHeader heading={heading} description="" />
      <div className="mb-5 mt-5">
        <TabComponent
          menus={tabs}
          activeTab={activeTab}
          changeActiveTab={onTabChange}
          isLoading={isLoading}
        />
      </div>
      <div className="border-b border-gray-200" />
      <div>{children}</div>
    </div>
  );
};
